import React from 'react';
import Footer from '../components/Footer';
import { motion } from 'framer-motion';

const OccupationalTherapy = () => {
  return (
    <>
      <div className='p-5 lg:p-12 bg-waves bg-cover lg:px-36 min-h-screen space-y-3 lg:grid grid-cols-2'>
        <div>
          <motion.div
            animate={{ x: 0 }}
            initial={{ x: -500 }}
            transition={{ delay: 0.1 }}
          >
            <h3 className='text-black mb-4 text-4xl font-bold lg:text-left md:text-center lg:pl-12'>
              Occupational Therapy
            </h3>
          </motion.div>
          <div className='lg:py-4 lg:pr-12'>
            <div className='bg-white p-6 rounded-lg shadow-lg text-left flex'>
              <p className='text-black sm:text-justify md:text-xl'>
                Custom designed for clients with fine and gross motor
                deficiencies, our certified occupational therapists work with
                your child and your family to enhance their adaptive functioning
                skills. Our Occupational Therapists are certified through the
                Alberta College of Occupational Therapists (ACOT) and specialize
                in teaching your child’s day to day essential skills including
                dressing, toileting, bathing and grooming. Our occupational
                therapists also specialize in employing sensory integration
                therapy which can be immensely valuable to students on the
                autism spectrum to help support regulation and emotional
                control. Comprehensive occupational therapy assessments are
                available for those seeking to further understand their child’s
                diagnosis and enhance their treatment options. Both FSCD vendor
                direct pay and private pay options are available.
              </p>
            </div>
          </div>
        </div>
        <div className='lg:pr-12'>
          <img
            className='sm:mx-auto h-auto rounded-3xl drop-shadow-2xl 2xl:mt-9 lg:mt-24'
            src='/occupationaltherapy.png'
            alt=''
          />
        </div>
      </div>
      <Footer />
    </>
  );
};

export default OccupationalTherapy;
